<div
  class="main-layout"
  [class.sidebar-collapsed]="sidebarCollapsed"
  [class.sidebar-mobile-open]="mobileSidebarOpen">
  <app-navbar (toggleSidebar)="toggleMobileSidebar()"></app-navbar>
  <button class="sidebar-backdrop" type="button" aria-label="Закрыть меню" *ngIf="mobileSidebarOpen" (click)="closeMobileSidebar()"></button>
  <div class="main-layout-body">
    <app-sidebar
      [collapsed]="sidebarCollapsed"
      (toggleCollapsed)="toggleSidebarCollapsed()"
      (navigated)="closeMobileSidebar()">
    </app-sidebar>
    <main class="content">
      <ng-content></ng-content>
    </main>
  </div>
</div>
